module.exports = __webpack_public_path__ + "static/img/bg_SeaBuilding_1.8aa9a4d1.png";